export const NAME = 'coupons';